import { render, staticRenderFns } from "./TransferTokenQueueTable.vue?vue&type=template&id=7091bb17&scoped=true"
import script from "./TransferTokenQueueTable.vue?vue&type=script&lang=js"
export * from "./TransferTokenQueueTable.vue?vue&type=script&lang=js"
import style0 from "./TransferTokenQueueTable.vue?vue&type=style&index=0&id=7091bb17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7091bb17",
  null
  
)

export default component.exports